"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a FILTER_RESPONSE request.
 */
var MessagingFilterResponse = /** @class */ (function () {
    /**
     * Create a new MessagingFilterResponse instance
     *
     * @param cid          the conversation ID
     * @param sessionID    the session ID
     * @param response     the messaging response
     * @param errorReason  a possible error reason
     */
    function MessagingFilterResponse(cid, sessionID, response, errorReason) {
        this.cid = cid;
        this.sessionID = sessionID;
        this.response = response;
        this.errorReason = errorReason;
    }
    return MessagingFilterResponse;
}());
exports.MessagingFilterResponse = MessagingFilterResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/messaging-filter-response.js
// module id = 1904
// module chunks = 1